import styled from "styled-components";


export const TitlePage = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0;
    border-radius: 10px;
    background: #f8f8f8;
    padding: 15px;

    span {
        margin-left: 10px;
        font-size: 20px;
    }
`